<template>
  <div>
    <h4>Materiais de Divulgação</h4>
    <b-card>
      <b-table
        :items="lista"
        :fields="fields"
        striped
        bordered
        show-empty
        small
      >
        <template #cell(actions)="row">
          <b-button variant="primary" size="sm" @click="row.toggleDetails">
            {{ row.detailsShowing ? "Esconder" : "Mostrar" }} Detalhes
          </b-button>
        </template>
        <template #row-details="row">
          <b-row class="justify-content-md-center">
            <b-col align-self="center" class="col-md-10">
              <b-card
                bg-variant="dark"
                text-variant="white"
                class="p-3 mb-3"
              >
                <b-container fluid>
                  <b-row>
                    <b>Descrição:</b> &nbsp; {{ row.item.descricao }}
                  </b-row>
                  <b-row v-if="row.item.tipo === 'VIDEO'">
                    <b>Link do Video:  </b>  &nbsp; <a style="color: white;" :href="row.item.path">  {{ row.item.path }} </a>
                  </b-row>
                  <b-row align-v="center" class="text-center" v-if="row.item.tipo === 'VIDEO'">
                    <b-col align-self="center" class="mt-2 col-md-12">
                      <div>
                        <b-embed
                          type="iframe"
                          aspect="21by9"
                          :src="row.item.path"
                          allowfullscreen
                        />
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-2" v-else>
                    <b-button
                      size="sm"
                      variant="warning"
                      @click="download(row.item.id)"
                      ><i class="fas fa-eye"></i> Visualizar Arquivo</b-button
                    >
                  </b-row>
                </b-container>
              </b-card>
            </b-col>
          </b-row>
        </template>
      </b-table>
    </b-card>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      lista: [],
      fields: [
        {
          key: "actions",
          label: "",
          class: "text-center",
        },
        {
          key: "id",
          label: "Código",
          class: "text-center",
        },
        {
          key: "titulo",
          label: "Título",
          class: "text-center",
        },
        {
          key: "tipo",
          label: "Tipo",
          class: "text-center",
        },
      ],
    };
  },
  methods: {
    download(id) {
      axios
        .get("/material-divulgacao/download/" + id)
        .then((response) => {
          window.open(response.data.url, "_blank");
        })
        .catch((erro) => {
          console.log(erro);
        });
    },
    getMateriais() {
      const vm = this;
      vm.lista = [];
      vm.loadingTable = true;
      axios
        .get("/adm/material-divulgacao/listar")
        .then((response) => {
          console.log(response.data);
          vm.lista = response.data;
        })
        .catch((erro) => {
          console.log(erro);
          vm.$swal("Atenção", "erro ao listar materiais", "error");
        })
        .finally(() => {
          vm.loadingTable = false;
        });
    },
  },
  mounted() {
    this.getMateriais();
  },
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/material_divulgacao/List.vue